import { FC, useState, useMemo } from 'react';
import { Box, CardMedia } from '@mui/material';

import { CardStyled, CardImageStyled, WrapperLink, getStyles } from './Card.styled';
import { CardDetails } from './CardDetails';
import { IProduct } from '../../interfaces/product';
import { reducerTypes } from '../../store/Product/types';
import { tGridTemplateColumns } from '../../react-pages/HomePage/OurProducts/OurProducts';
import LazyLoad from 'react-lazyload';
import { useAppDispatch } from 'src/hooks/reduxHooks';

export type tagType = 'check' | 'check_outline' | 'hot' | 'hot_outline';

type Props = {
  product: IProduct;
  columns: tGridTemplateColumns;
  imageHeight?: number;
  forProductPage?: boolean;
};

const CardControlled: FC<Props> = ({ product, columns, imageHeight, forProductPage }) => {
  const dispatch = useAppDispatch();
  const styles = getStyles({ columns, imageHeight });
  const [isWishlist, setIsWishlist] = useState(() => {
    try {
      const LS: any = typeof window !== 'undefined' ? localStorage.getItem('favoriteProducts') : undefined;
      const wishlistProducts = JSON.parse(LS) || [];
      const productToCheck = wishlistProducts?.find((pr: any) => pr?.id === product?.id);
      if (productToCheck) {
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  });

  const link = useMemo(() => {
    return `/products${
      product?.model?.brand?.url
        ? '/' + product?.model?.brand?.url?.trim()?.replaceAll(' ', '-')?.replaceAll('/', '-')?.replaceAll('\\', '-')
        : ''
    }${
      product?.model?.name
        ? '/' + product?.model?.name?.trim()?.replaceAll(' ', '-')?.replaceAll('/', '-')?.replaceAll('\\', '-')
        : ''
    }${product?.slug ? '/' + product?.slug?.trim()?.replaceAll('/', '-') : ''}`;
  }, [product]);

  function handleLink() {
    dispatch({ type: reducerTypes.GET_PRODUCT, payload: product });
  }

  const handleWishList = () => {
    const LS: any = localStorage.getItem('favoriteProducts');
    let wishlistProducts = JSON.parse(LS) || [];
    const productToCheck = wishlistProducts.find((pr: any) => pr.id === product.id);
    if (productToCheck) {
      wishlistProducts = wishlistProducts.filter((pr: any) => pr.id !== productToCheck.id);
      setIsWishlist(false);
    } else {
      wishlistProducts.push(product);
      setIsWishlist(true);
    }
    localStorage.setItem('favoriteProducts', JSON.stringify(wishlistProducts));
  };

  return (
    <CardStyled style={{ padding: forProductPage ? '0 12px' : 'unset' }}>
      <WrapperLink href={link} onClick={handleLink} tabIndex={-1} aria-label={product?.name} title={product?.name}>
        <CardImageStyled columns={columns}>
          {product?.images?.length ? (
            <LazyLoad height={200} offset={100} style={{ width: '100%' }}>
              <CardMedia component='img' image={product?.images[0].url} alt={'title'} sx={styles.CardMedia} />
            </LazyLoad>
          ) : (
            <LazyLoad height={200} offset={100} style={{ width: '100%' }}>
              <CardMedia component='img' image={'/img/card_img.png'} alt={'title'} sx={styles.CardMedia} />
            </LazyLoad>
          )}
        </CardImageStyled>
      </WrapperLink>

      <Box>
        <CardDetails product={product} columns={columns} isWishlist={isWishlist} handleWishList={handleWishList} />
      </Box>
    </CardStyled>
  );
};

export default CardControlled;
